import React from 'react'
import { Grid, GridItem } from '../grid'
import DetailsItem from '../details-item'
import {
  formatAdditionalDiamond,
  formatPrimaryDiamondQty
} from './field-formatters'

const StockItemDetails = props => (
  <Grid>
    <GridItem col='1/2'>
      <DetailsItem title='Primary Diamond(s)' value={formatPrimaryDiamondQty(props.data)} />
    </GridItem>
    <GridItem col='1/2'>
      <DetailsItem title='Additional Diamond(s)' value={formatAdditionalDiamond(props.data)} />
    </GridItem>
  </Grid>
)

export default StockItemDetails



// WEBPACK FOOTER //
// ./src/components/jewelry-details/stock-item-details.js